import { Platform } from "react-native";
import SBLocation, { SBackgroundLocation } from "servisofts-background-location";
import SSocket from "servisofts-socket";
import MDLAbstract from "../MDLAbstract";
import { EventListener } from "./types";
import Config from "../../Config";
import HTTP from "../../HTTP";
import { SNavigation } from "servisofts-component2";

export default class backgroundLocation extends MDLAbstract<EventListener> {
    active: boolean = false;
    isRunning = false;
    constructor() {
        super();
        this.verifyStatus().then(e => {
            this.setActive(e);
        })
        this.startHilo();

    }

    startHilo() {
        this.isRunning = true;
        this._hilo();
    }
    _hilo = async () => {
        if (!this.isRunning) {
            return;
        }
        let status = false;
        // console.log("[DEBUG] hilostatus");
        try {
            status = await this.verifyStatus();
        } catch (error) {
            // console.log("[DEBUG] hilostatus Error", error);
        }
        this.setActive(status);
        setTimeout(() => {
            this._hilo();
        }, 5000);
    }

    verifyStatus = async () => {
        if (Platform.OS == "web") {
            this.active = this.active;
            return this.active;
        }
        const e: any = await SBLocation.isActive()
        if (e.estado == "exito") {
            return true
        }
        return false;
    }
    stop = async () => {
        SBLocation.stop();
        this.setActive(false);
    }
    setActive(active: boolean) {
        if (active == this.active) {
            return;
        }
        this.active = active
        this.dispatchEvent({ type: "changeStatus", active: this.active })
    }

    start = async ({ key_usuario = "", plate = "" }) => {
        try {
            await this.verifyPermissions();
        } catch (error) {
            SNavigation.navigate("/permiso");
            throw { error: "Debes otorgar los permisos" };
        }
        const e: any = await SBLocation.start({
            nombre: "Ubicación en tiempo real de ROR",
            label: "Compartiendo ubicación en tiempo real",
            minTime: 5000,
            minDistance: 1,
            // @ts-ignore
            key_usuario: key_usuario + "__" + plate,
            url: Config.apis.usuario + "/gps/background_location",
            // url: "http://192.168.2.1:30031/api",
            // url: "https://dhm.servisofts.com/images/api",
            component: "backgroundLocation",
            type: "onLocationChange"
        })

        if (e.estado == "exito") {
            this.setActive(true);
            return e;
        }
        throw e;

    }

    testSend = async ({ key_usuario = "", plate = "", latitude = 0, longitude = 0 }) => {
        const response: any = await HTTP.POST({
            url: Config.apis.usuario + "/gps/background_location",
            body: {
                component: "backgroundLocation",
                type: "onLocationChange",
                key_usuario: key_usuario + "__" + plate,
                data: {
                    tipo: "on_location_change",
                    latitude: latitude,
                    longitude: longitude,
                    accuracy: 10,
                    speed: 0,
                    altitude: 0,
                    heading: 0,
                    time: new Date().getTime(),

                }

            }

        });
    }

    // getBackgroundLocationInMatricula = async (id_expedicion: any) => {
    //     try {
    //         const response = await HTTP.GET({
    //             url: Config.apis.usuario + "/database/rowsin/background_location/plate/" + JSON.stringify(id_expedicion).replace("[", "").replace("]", "").replace(/"/g, "'"),
    //             token: MDL.usuario.session?.token,
    //         });
    //         if (!response || response.length <= 0) return null
    //         return response as any;
    //     } catch (error: any) {
    //         throw error?.message
    //     }
    // }
    getMapRegion(points: any, padding = 1.2): any {
        if (!points || points.length === 0) return {
            // espanha
            latitude: 40.4168,
            longitude: -3.7038,
            latitudeDelta: 6,
            longitudeDelta: 6
        };

        let minLat = points[0].latitude;
        let maxLat = points[0].latitude;
        let minLng = points[0].longitude;
        let maxLng = points[0].longitude;

        points.forEach((point: any) => {
            if (point.latitude < minLat) minLat = point.latitude;
            if (point.latitude > maxLat) maxLat = point.latitude;
            if (point.longitude < minLng) minLng = point.longitude;
            if (point.longitude > maxLng) maxLng = point.longitude;
        });

        const latitude = (minLat + maxLat) / 2;
        const longitude = (minLng + maxLng) / 2;
        const latitudeDelta = (maxLat - minLat) * padding || 0.01; // Padding del 20%
        const longitudeDelta = (maxLng - minLng) * padding || 0.01;

        return {
            latitude,
            longitude,
            latitudeDelta,
            longitudeDelta
        };
    }

    async verifyPermissions() {
        const location = await SBackgroundLocation.isAccessFineLocationGranted();
        const backgroundLocation = await SBackgroundLocation.isAccessBackgroundLocationGranted();
        const notification = await SBackgroundLocation.isNotificationPermissionGranted();
        const batery = await SBackgroundLocation.isBatteryOptimizationDisabled();
        if (!location.granted || !backgroundLocation.granted || !notification.granted || !batery.granted) {
            throw { location, backgroundLocation, notification, batery }
        }
        return true;
    }
}